



















import { Vue, Component } from "@/shared/vuepack";

@Component({})
export default class HsaBankLegalFooter extends Vue {
  get esignUrl () {
    return "https://hsabank.bynder.com/m/43215023c0dcfad7/original/Health-Savings-Account-HSA-Electronic-Signatures-ESIGN-and-Online-Services-Agreement.pdf";
  }

  get privacyUrl () {
    return "https://hsabank.com/HSABank/About/Security/Privacy-and-Opt-Out-Notice";
  }

  get custodialAgreementUrl () {
    return "https://hsabank.bynder.com/m/e4866b5e5c65ba89/original/Health-Savings-Account-Custodial-Agreement.pdf";
  }
}
